import React from 'react'
import useFirebaseSession from 'hooks/useFirebaseSession'
import HideableWarningMessage from 'components/shared/alerts/HideableWarningMessage'

function IndiaDisclaimerAlert({ visitorIsFromIndia }) {

    const { userIsLoggedIn, sessionInitialized } = useFirebaseSession()
    const showDisclaimer = visitorIsFromIndia && !userIsLoggedIn && sessionInitialized
    return (
      <HideableWarningMessage
        show={showDisclaimer}
        text={
          "The Juggernaut is a New York-based digital publication focused on South Asian news. It has no relationship whatsoever to Juggernaut Books Pvt. Ltd."
        }
      />
    );
}

export default IndiaDisclaimerAlert